<template>
  <woot-dropdown-item>
    <div class="item-wrap">
      <woot-button variant="clear" @click="onClick">
        <div class="button-wrap">
          <div class="name-label-wrap" :class="{ 'faded-text': selected }">
            <!-- Robot icon for automation labels -->
            <div v-if="isAutomationLabel" class="automation-icon-wrap">
              <svg
                class="automation-robot-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                :style="{ color: color }"
              >
                <path d="M13 2v2h-2V2h2zm-1 4a6 6 0 0 0-6 6v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a6 6 0 0 0-6-6zM8 12h2v2H8v-2zm6 0h2v2h-2v-2zm-5 5h6v2H9v-2zM2 10h2v6H2v-6zm18 0h2v6h-2v-6z"/>
              </svg>
            </div>
            <div
              v-if="excludeFromDefaultViews"
              class="automation-icon-wrap"
              :title="$t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.EXCLUDE_FROM_DEFAULT_VIEWS')"
            >
              <fluent-icon
                icon="eye-hide"
                size="14"
                :style="{ color: color }"
              />
            </div>
            <!-- Color dot for normal labels -->
            <div
              v-else-if="color && !isAutomationLabel"
              class="label-color--display"
              :style="{ backgroundColor: color }"
            />
            <span class="label-text">{{ title }}</span>
          </div>
          <div>
        <span v-if="selected" class="checkmark">✔</span>
         </div>
        </div>
      </woot-button>
    </div>
  </woot-dropdown-item>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    automation: {
      type: Boolean,
      default: false,
    },
    contactAutomation: {
      type: Boolean,
      default: false,
    },
    excludeFromDefaultViews: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAutomationLabel() {
      return this.automation || this.contactAutomation;
  },
  },
  methods: {
    onClick() {
      this.$emit('click', this.title);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-wrap {
  @apply flex;

  :deep(.button__content) {
    @apply w-full;
  }

  .button-wrap {
    @apply flex justify-between items-center w-full;

    &.active {
      @apply flex font-semibold text-woot-700 dark:text-woot-600;
    }

    .name-label-wrap {
      @apply flex min-w-0 flex-1 items-center;

      .label-color--display {
        @apply mr-2 rtl:mr-0 rtl:ml-2;
      }

      .label-text {
        @apply overflow-hidden text-ellipsis whitespace-nowrap pr-2 leading-[1.3];
      }

      .icon {
        @apply text-sm;
      }
    }
  }

  .checkmark {
  @apply text-green-500 text-sm font-bold ml-2;
  }
  
.faded-text {
  opacity: 0.5;
}

  .label-color--display {
    @apply rounded-md h-3 mr-1 rtl:mr-0 rtl:ml-1 min-w-[0.75rem] w-3 border border-solid border-slate-50 dark:border-slate-600;
  }

  .automation-icon-wrap {
    @apply flex items-center justify-center mr-2 rtl:mr-0 rtl:ml-2;
  }

  .automation-robot-icon {
    @apply w-3.5 h-3.5;
  }
}
</style>
